import type { MemberType } from '@/components/People/PeopleFilterSelector';

export default function getInviteLink({
  inviteCode,
  kind,
  memberType,
  publicUrl,
}: {
  inviteCode?: string | null;
  kind: 'organization' | 'team';
  memberType?: MemberType;
  publicUrl: string | undefined;
}) {
  const inviteUrl = new URL(`/${kind}/invite`, publicUrl);
  inviteUrl.searchParams.set('code', inviteCode || '');
  if (memberType) {
    inviteUrl.searchParams.set('memberType', memberType);
  }

  return inviteUrl.toString();
}
